import * as React from 'react';
import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import PlatformConditional from 'Components/PlatformConditional';
import FormEditingHandler from 'Containers/FormEditingHandler';
import { docType } from '../utils';
import MotorFuncHuntForm from './Form';
import UHDRSHistory from './HistoryRowData/UHDRS';

const MotorFuncHuntHistory = ({
  documents,
  startEdit,
  view,
}: {
  documents: IDocumentWithTypeV2<'uhdrsMotorRatingScale'>[];
  startEdit: StartEdit;
  view?: IView;
}): React.JSX.Element => {
  return (
    <React.Fragment>
      <PlatformConditional platform="huntington">
        <React.Fragment>
          <UHDRSHistory documents={documents} startEdit={startEdit} view={view} />
        </React.Fragment>
      </PlatformConditional>
    </React.Fragment>
  );
};

const MotorFuncHunt = ({ documents }: IOwnProps): React.JSX.Element => {
  return (
    <FormEditingHandler name="motorFunctionHuntington" documents={documents}>
      {(editing, startEdit, formData, view): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name={'motorFunctionHuntington'}
            headerId={
              docType(documents, editing, view) === 'uhdrsMotorRatingScale'
                ? 'motorFunctionHuntington.uhdrs'
                : 'motorFunctionHuntington.title'
            }
            editing={editing}
            editButtons={<div />}
          />
          {editing || view?.viewing ? (
            <MotorFuncHuntForm
              formData={formData}
              document={documents.find(d => d._id === (editing || view?.viewing))}
              editing={editing}
              viewing={!!view?.viewing}
            />
          ) : null}
          {!editing && !view?.viewing ? (
            <MotorFuncHuntHistory documents={documents} startEdit={startEdit} view={view} />
          ) : undefined}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'uhdrsMotorRatingScale'>>;
}

export default MotorFuncHunt;
